/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SentMessage } from './SentMessage';
import {
    SentMessageFromJSON,
    SentMessageFromJSONTyped,
    SentMessageToJSON,
} from './SentMessage';

/**
 * 
 * @export
 * @interface SentMessagesResponse
 */
export interface SentMessagesResponse {
    /**
     * 
     * @type {string}
     * @memberof SentMessagesResponse
     */
    begin?: string;
    /**
     * 
     * @type {string}
     * @memberof SentMessagesResponse
     */
    end?: string;
    /**
     * 
     * @type {Array<SentMessage>}
     * @memberof SentMessagesResponse
     */
    records?: Array<SentMessage>;
}

/**
 * Check if a given object implements the SentMessagesResponse interface.
 */
export function instanceOfSentMessagesResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SentMessagesResponseFromJSON(json: any): SentMessagesResponse {
    return SentMessagesResponseFromJSONTyped(json, false);
}

export function SentMessagesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SentMessagesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'begin': !exists(json, 'begin') ? undefined : json['begin'],
        'end': !exists(json, 'end') ? undefined : json['end'],
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(SentMessageFromJSON)),
    };
}

export function SentMessagesResponseToJSON(value?: SentMessagesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'begin': value.begin,
        'end': value.end,
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(SentMessageToJSON)),
    };
}

